<template>
    <div class="card mt-3 mb-3">
        <div class="card-header">Explanation</div>
        <div class="card-body text-start">
            <h5>Extracted Semantic Frame</h5>
            <p class="card-text" v-if="qt.start"><span class="fw-bold">Origin: </span> {{ qt.start }}</p>
            <p class="card-text" v-if="qt.end"><span class="fw-bold">Destination: </span> {{ qt.end }}</p>
            <p class="card-text" v-if="qt.via_route"><span class="fw-bold">Via: </span> {{ qt.via_route }}</p>
            <p class="card-text"><span class="fw-bold">Directional:</span> {{ qt.directional }}</p>
            <div class="container" v-if="hasFilters">
                <h6>Filters</h6>
                <ul>
                    <li v-for="(filter, idx) in qt.filters" :key="idx">
                        <p class="card-text"><span class="fw-bold">{{ filter.name }}: </span> {{ filter.value }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["qt"],
    computed: {
        hasFilters() {
            return this.qt.filters && this.qt.filters.length > 0;
        },
    },
}
</script>
<style scoped></style>